module.exports = __webpack_public_path__ + "static/media/warning.1c9e307e.svg";